export default {
    USER_ID: `eLblmxLkH9LCDWNc3`, //userID
    TEMPLATE_ID: `template_l1up5xa`,         //templateID
    SERVICE_ID: 'service_7rfc1cf',
}
